import { RecommendationType } from "@explorance/mly-types";

export const getRecommendationTypes = () => {
  return Object.keys(RecommendationType).filter(
    (type) =>
      type !== RecommendationType.recommendation &&
      type !== RecommendationType.generalRecommendation
  );
};
